import React from 'react';
import PropTypes from 'prop-types';
import cfg from 'cfg';
import get from 'lodash/get';
import AutoComplete from 'material-ui/AutoComplete';

class TeamPicker extends React.Component {
    constructor(props) {
        super(props);

        const keyProperty = this.getPropertyFor(props.customKey ? props.propKey : 'teamId');

        this.state = {
            keyProperty,
            teams: [],
            searchText: '',
            teamId: props[keyProperty] && +props[keyProperty],
        };

        this.autoComplete = { current: {} };

        this.setAutoCompleteRef = element => {
            this.autoComplete.current = element;
        };
    }

    componentDidMount() {
        this.loadTeams();
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.tournamentId !== this.props.tournamentId) {
            this.loadTeams();
        }
        if (nextProps.teamId !== this.props.teamId) {
            this.setState({ teamId: nextProps.teamId }, () => {
                this.loadTeams();
            });
        }
        if (nextProps.resetPicker === true) {
            this.handleReset();
        }
    };

    getPropertyFor(key) {
        return get(this, `props.propsMap[${key}]`, key);
    }

    loadTeams() {
        const { tournamentId } = this.props;
        const { teamId } = this.state;
        let searchText = this.state.searchText;

        return fetch(`${cfg.apis.ss2}/teams`)
            .then(response => response.json())
            .then(teams => {
                const team = teams.find(t => t.id === teamId);

                if (team) {
                    searchText = team.name;
                }

                if (tournamentId) {
                    teams = teams.filter(t => t.tournamentTemplateId.includes(tournamentId));
                }

                this.setState({
                    teams,
                    searchText,
                });
            })
            .catch(e => {
                console.error(e);
            });
    }

    handleTeamChange = (srting, index) => {
        const team = this.state.teams[index];
        //const { keyProperty } = this.state;

        if (team) {
            this.props.onChange(this.state.keyProperty, team.id);
            //this.props.onChange({ [keyProperty]: team.id, [team.id]: team.name });
        } else {
            this.props.onChange(this.state.keyProperty, null);
        }
    };

    handleUpdateInput = searchText => {
        this.setState({ searchText });
    };

    handleOnClose = () => {
        const ac = this.autoComplete.current;

        if (ac.state.searchText === '') {
            this.props.onChange(this.state.keyProperty, null);
        }
    };

    handleReset = () => {
        this.setState({
            searchText: '',
            teamId: null,
        });
    };

    render() {
        return (
            <AutoComplete
                ref={this.setAutoCompleteRef}
                hintText="Start typing team name"
                dataSource={this.state.teams}
                dataSourceConfig={{ text: 'name', value: 'id' }}
                onNewRequest={this.handleTeamChange}
                searchText={this.state.searchText}
                onUpdateInput={this.handleUpdateInput}
                onClose={this.handleOnClose}
                floatingLabelText={this.props.label || 'Team'}
                maxSearchResults={50}
                value={this.state.teamId}
                openOnFocus={this.state.teams.length < 30}
                filter={AutoComplete.fuzzyFilter}
                fullWidth
                menuStyle={{ maxHeight: '500px', overflow: 'scroll' }}
            />
        );
    }
}

TeamPicker.defaultProps = {
    sportId: 1,
    resetPicker: false,
};

TeamPicker.propTypes = {
    sportId: PropTypes.number,
    label: PropTypes.string,
    customKey: PropTypes.string,
    propKey: PropTypes.string,
    teamId: PropTypes.number,
    tournamentId: PropTypes.number,
    resetPicker: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

export default TeamPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TeamPicker.js
 **/